<template>
  <div class="table">
    <!-- 添加按钮 -->
    <el-button
      class="btn btn1"
      type="primary"
      :disabled="addTag"
      style="margin: 0 20px 5px 0px"
      icon="el-icon-circle-plus-outline"
      @click="poplog"
      >{{ $t("message.button.add") }}</el-button
    >

    <!-- 弹出框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('message.Auth.authShift')"
      v-if="dialogVisible"
      ref="tableData"
      :visible.sync="dialogVisible"
      width="50%"
      class="demo-ruleForm"
      @close="closeEdit"
    >
      <el-form
        :label-position="labelPosition"
        label-width="110px"
        :rules="rules"
        :model="addForm"
      >
        <el-form-item :label="$t('message.Auth.isAuth')" prop="enabled">
          <el-select
            v-model="addForm.enabled"
            :placeholder="$t('message.Auth.isAuth')"
            :style="inputWidth"
          >
            <!-- <el-option :label="$t('message.table.enabled')" value="1"></el-option>
            <el-option :label="$t('message.table.disabled')" value="0"></el-option> -->
            <el-option
              :label="enable.label"
              :value="enable.value"
              v-for="enable in enabledList"
              :key="enable.index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.Auth.authUser')" prop="enabled">
          <el-select
            v-model="addForm.transferUser"
            :placeholder="$t('message.Auth.authUser')"
            :style="inputWidth"
          >
            <el-option
              :label="user.userName"
              :value="user.id"
              v-for="user in transferUserList"
              :key="user.index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('message.Auth.scope')"  prop="enabled">
          <!-- <el-select v-model="addForm.subclassIds">
            <el-option :label="changeList.label" :value="changeList.value" v-for="changeList in classList" :key="changeList.id"></el-option>
          </el-select> -->
          <el-cascader
            :placeholder="$t('message.Auth.scope')"
            v-model="addForm.subclassIds"
            :options="classList"
            :props="props"
            :show-all-levels="false"
            :style="inputWidth"
            @change="selectMethod"
            filterable
          ></el-cascader>
        </el-form-item>
        <el-form-item :label="$t('message.placeholder.startDate')" required>
          <el-date-picker
            v-model="addForm.startTime"
            type="datetime"
            :style="inputWidth"
            placeholder="选择开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="$t('message.placeholder.endDate')" required>
          <el-date-picker
            v-model="addForm.endTime"
            type="datetime"
            :style="inputWidth"
            placeholder="选择结束时间"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small"  @click="dialogVisible = false">{{$t('message.button.cancel')}}</el-button>
        <el-button size="small" type="primary" @click="addOrUpDataEvent"
          >{{$t('message.button.affirm')}}</el-button
        >
      </span>
    </el-dialog>
    <!-- 表格内容 -->
    <div>
      <template>
        <el-table
          :data="tableData"
          stripe
          border
          :header-cell-style="{background:'#F8F8F9',color:'#64666A'}"
          style="width: 100%"
          @row-dblclick="edit"
        >
          <!-- <el-table-column type="index" :label="$t('message.table.SN')" prop="index" width="50">
          </el-table-column> -->
          <el-table-column prop="enabledLabel" :label="$t('message.Auth.isAuth')" sortable width="180">
          </el-table-column>
          <el-table-column prop="transferUserName" :label="$t('message.Auth.authUser')" sortable width="180">
          </el-table-column>
          <el-table-column prop="subclassIdNames" :label="$t('message.Auth.scope')" sortable width="480">
          </el-table-column>
          <el-table-column prop="startTime" type="datetime" :label="$t('message.placeholder.startDate')" sortable>
          </el-table-column>
          <el-table-column prop="endTime" :label="$t('message.placeholder.endDate')" :sortable="true">
          </el-table-column>
          <!-- <el-table-column prop="enabled" label="是否启用"> </el-table-column> -->
          <el-table-column fixed="right" :label="$t('message.table.actions')" width="200">
            <template slot-scope="scope" >
              <!-- <span>{{scope.row}}</span> -->
              <el-button
                type="primary"
                :disabled="!scope.row.disabled"
                icon="el-icon-edit"
                @click="editauthorize(scope.$index, scope.row)"
                size="mini"
                style="background: #409EFF "
                >{{$t('message.button.edit')}}</el-button
              >
              <el-button
                
                :disabled="!scope.row.disabled "
                type="danger"
                icon="el-icon-delete"
                @click="deleteRow(scope.$index, tableData)"
                size="mini"
              >
                {{$t('message.button.delete')}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      tableData: [],
      isAdmin:false,
      addTag: false,
      tableDataobj: {},
      classFromView: [],
      transferUserList: [],
      classList: [],
      labelPosition: "right",
      inputWidth: {
        width: "85%",
      },

      dialogVisible: false,
      labelPosition: "right",
      props: {
        multiple: true,
      },
      // 弹出框
      addForm: {
        authUser: 0,
        enabled: "",
        enabledLabel: "",
        // subclassIdNames:"",
        transferUser: [],
        subclassIds: [],
        startTime: "",
        endTime: "",
        classId: '',
      },
      // 弹出框校验
      rules: {
        enabled:[
        { required: true, message: '请输入', trigger: 'blur' },

        ],
      },
      // addformAuthorizationRules: {
      //   enabled: [
      //   { required: true, message: '必填项不能为空' }
      //   ],
      //   date1: [
      //     { type: 'date', required: true, message: '请选择日期'}
      //   ],
      //   date2: [
      //     { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
      //   ],
      // },

      enabledList: [
        { value: 1, label: "是" },
        { value: 0, label: "否" },
      ],
      isOne: [
        { value: 1, label: "转入" },
        { value: 0, label: "转出" },
      ],
    };
  },
  methods: {
    selectMethod(e){
      console.log(e);
      // let classId = e[0].shift();
      
      this.classId = !e.length ? "" : e[0][0];
      this.classList.map(i => {
        const disabled =  e.length && i.value != this.classId;
        this.$set(i,'disabled',disabled)
        
      })
      console.log(this.classList);
    },
    // lode数据  /authTsf/findAuthTsfList
    async getUserAuthorization() {
      let obj = {...this.$store.state.objectId};
      // console.log(this);
      // obj.id = this.$store.state.objectId.id + "";
      // obj.classId = this.$store.state.objectId.classId + "";
      // obj.subClassId = this.$store.state.objectId.subClassId + "";
      obj.tableId = 65;
      obj.tenantId = 1;
      // 进行访问后端拿数据
      console.log(obj);
      const { data: res } = await this.$http.get(
        `/pmdm/authTsf/findAuthTsfList${this.params(obj)}`
      );
      
      console.log(res);
      console.log(res.object.authTransferVoList);
      this.addTag = !res.object.addTag;
      // 是否是自己创建
      this.classList = res.object.clsvoList;
      this.isAdmin = res.object.adminTag == 1 ;
      // this.transferUserList = [...res.object.users];
      this.transferUserList = res.object.users.map((i) => ({
        id: i.id,
        userName: i.userName,
      }));

      var session = window.sessionStorage.getItem("userContext");
      session = JSON.parse(session);
      console.log(session);

      // this.transferUserList.find(i =>i.id == session.id).disabled = true;


      // this.transferUserList = res.object.users.map(i =>i.id);
      // console.log(this.transferUserList);

      // let authdata = res.object.authTransferVoList;
      this.tableData = res.object.authTransferVoList.map((i) => {
        // console.log(i);
        let obj = {
          ...i,
          enabledLabel: this.enabledList.find((j) => j.value == i.enabled)
            .label,
          transferUserName:
            this.transferUserList.find((j) => j.id == i.transferUser)
              ?.userName || session.loginId,
          disabled: this.isAdmin || i.selfCreate,
          // startTime: i.startTime.replace(/T/, ' '),
          // endTime: i.endTime.replace(/T/, ' '),
        };
        return obj;
      });
      // for (let i = 0; i < authdata.length; i++) {
      // const e = res.object.authTransferVoList[i];
      //   this.$set(this.tableDataobj,"aa",res.object.authTransferVoList[i])
      //   if(res.object.authTransferVoList[i].enabled == 1){
      //     this.$set(this.tableDataobj,'e','是')
      //   }else{
      //     this.$set(this.tableDataobj,'e','否')
      //   }
      //   if (res.object.authTransferVoList[i].transferUser) {
      //     console.log(res.object.authTransferVoList[i].transferUser);
      //     for(let j=0;j<=res.object.users.length;j++){
      //       let user=res.object.users[j].id+'';
      //       let user1=res.object.authTransferVoList[i].transferUser+'';
      //     if(user.equals(user1)){
      //     }
      //   }
      //   }

      // }
      console.log(this.tableData);
      // 整理为展示需要的数据
      // this.addForm.transferUser = res.object.users
      // console.log(this.addForm.transferUser);
      // this.transferUserList = [...res.object.users]
    },

    // “添加按钮”进行显示弹出框
    poplog() {
      for (const i in this.addForm) {
        this.addForm[i] = "";
      }
      this.classList.map(i => {
        this.$set(i,'disabled',false)
        
      })

      this.dialogVisible = true;
    },
    // 添加数据
    async addOrUpDataEvent(e) {
      console.log(this.$store.state.objId_);
      this.addForm.authUser = this.$store.state.objectId.id;
      // console.log(this.addForm);
      let fromdata = this.addForm;
      if (!(fromdata.enabled == 0 || fromdata.enabled == 1)) {
        this.$message.error("是否授权选择错误");
        return;
      }
      if (
        fromdata.transferUser == "" ||
        fromdata.startTime == "" ||
        fromdata.endTime == ""
      ) {
        this.$message.error("数据不能为空");
        return;
      }
      let sub = this.addForm.subclassIds.map((i) => {
        return i[i.length - 1];
      });
      console.log(sub);
      this.$set(this.addForm, "subclassIds", sub.join(";"));
      // for(let x = 0; x <= sublength; x++){

      //   this.$set(this.tableDataobj,'subclassIds',)
      // }
      // return
      if (fromdata.subclassIds == "") {
        this.$message.error("授权内容不能为空");
        return;
      }
      console.log(this.classId);
      this.addForm.classId = this.classId;
      axios
        .post("/pmdm/authTsf/saveOrUpdateAuthTsf", this.addForm)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            // this.tableData.push(this.addForm);
            this.getUserAuthorization();
            this.dialogVisible = false;
            this.addForm = {};
          } else {
            this.$message.error("添加失败！");
          }
        });
    },
    // 删除数据  /authTsf/deleteAuthTsfBatch
    deleteRow(index, tableData) {
      console.log(index, tableData);
      let authTransferVos = [{ id: tableData[index].id }];
      const obj = { authTransferVos };
      // const{data:res} =await this.$http.post(`/pmdm/authTsf/deleteAuthTsfBatch${this.params(deletId)}`);
      axios.post("/pmdm/authTsf/deleteAuthTsfBatch", obj).then((res) => {
        console.log(res);
        if (res.status === 200) {
          this.$message({
            type: "success",
            message: res.data.message,
          });
          this.getUserAuthorization();
        } else {
          console.log("删除失败了");
        }
      });

      //删除
      // let obj = {};
      // obj.id = this.$store.state.objectId.id + "";
      // obj.classId = this.$store.state.objectId.classId + "";
      // obj.subClassId = this.$store.state.objectId.subClassId + "";
      // //console.log(this.$refs.xGrid);
      // var removeRow = this.$refs.xGrid.getCheckboxRecords();
      // console.log(removeRow);
      // var del_table = [];
    },
    // 编辑表单信息
    edit(e) {
      this.editauthorize(e.index, e);
    },
    editauthorize(index, e) {
      console.log(index);
      console.log(e);
      this.addForm = { ...e };

      // 第一种方式“平铺后展示”
      let arr = [];
      this.classList.map((i) => {
        let a = i.children.map((j) => ({ a: i.value, b: j.value }));
        arr = [...arr, ...a];

      });
      this.addForm.subclassIds = e.subclassIds.split(";").map((i) => {
        return Object.values(arr.find((j) => j.b == i));
      });

      // this.classId = !e.length ? "" : e[0][0];
      this.classList.map(i => {
        const disabled =  this.addForm.subclassIds.length && i.value != this.addForm.subclassIds[0][0];
        this.$set(i,'disabled',disabled)
      })
      console.log(this.addForm);
      
      // 第二种方式“直接寻值赋值”
      // this.addForm.subclassIds = e.subclassIds.split(';').map(i =>{

      //   let n = this.classList.find(j => {
      //     if (j.children.some(k => k.value == i)) {
      //       return j.value
      //     }
      //   }).value
      //   return [n,+i]
      // })
      this.dialogVisible = true;
      
      // this.addForm.enabled = e.enabledLabel;
      // this.addForm.transferUser = e.transferUserName;
      // this.addForm.subclassIds = e.subclassIdNames;
      // this.addForm.startTime = e.startTime;
      // this.addForm.endTime = e.endTime;
    },
    //  修改增加数据  /authTsf/saveOrUpdateAuthTsf

    // “取消”按钮操作
    closeSave() {
      this.getUserAuthorization();
    },
    closeEdit() {
      // this.$refs.editFormRef.clearValidate();
      this.privsForm = {};
    },
    resetForm() {
      console.log(this.addForm);

      for (const i in this.addForm) {
        this.addForm[i] = "";
      }

      // this.addForm = {
      //   authUser:0,
      //   enabled: "",
      //   enabledLabel:"",
      //   // subclassIdNames:"",
      //   transferUser: [],
      //   subclassIds: [],
      //   startTime:"",
      //   endTime:"",
      // }
    },
  },
  computed: {
  },
  components: {

  },
  watch: {},
  created() {
    this.getUserAuthorization();

    

    this.tableData.map((i, e) => (i.index = e));
    // this.loadUserPriv();
    setTimeout(() => {
      this.loading = false;
    }, 500);
  },
};
</script>

<style scoped>
.table {
  margin-top: 6px;
  background: #fff;
  padding: 10px 15px;
}
</style>
